export const NETFLIX_LOGO ="https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png"

export const NETFLIX_BG_URL="https://assets.nflxext.com/ffe/siteui/vlv3/a56dc29b-a0ec-4f6f-85fb-50df0680f80f/2f8ae902-8efe-49bb-9a91-51b6fcc8bf46/IN-en-20240617-popsignuptwoweeks-perspective_alpha_website_large.jpg";

export const USER_LOGO= "https://occ-0-3646-3647.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABTZ2zlLdBVC05fsd2YQAR43J6vB1NAUBOOrxt7oaFATxMhtdzlNZ846H3D8TZzooe2-FT853YVYs8p001KVFYopWi4D4NXM.png?r=229"

export const API_Option = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjODRiMGY4MDVmMzFlNDEyNTUyZjlkMGM5MGJjMDg1ZiIsIm5iZiI6MTcxOTc4MDgxNi43NDIyNTUsInN1YiI6IjY2ODFjNDMzYWRhYjJlODQ5OTM0YWUzMyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.7FyVYs981yY9VX8Aa5LCddabVJd67Y5uIZsWryHykMQ'
    }
  };
  
export const URL_Trailer ='https://api.themoviedb.org/3/movie/';

export const POSTER_URL= "https://image.tmdb.org/t/p/w500/"

export const number = Math.floor(Math.random()*20);

export const SUPPORTED_LANGUAGES=[
  {identifier:"en",name:"English"},
  {identifier:"hi",name:"Hindi"},
  {identifier:"cg",name:"Chhatisgarhi"}
]; 